import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Grow, Typography, Grid, IconButton, Box } from "@mui/material";
import { Alert } from "../layout";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { useEffect } from "react";

export default function InputImg(props) {
  const { t } = useTranslation();
  const {
    label = "Upload Images",
    values = [],
    name,
    error = null,
    onChange,
    rmv,
    src,
    defImg = process.env.PUBLIC_URL + "/assets/img/app/add-img.png",
    ...other
  } = props;

  const [imgsSrc, setImgsSrc] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const maxUpl = 1;
  const maxSize = 3;

  const showPreview = (e) => {
    const imgs = e.target.files;
    const imgsArray = Array.from(imgs).slice(0, 1);

    imgsArray.map((file) =>
      file.size / 1048576 < maxSize
        ? imgsSrc.length + imgs.length <= maxUpl
          ? setImgsSrc((x) => [...x, URL.createObjectURL(file)])
          : setAlert({
              isOpen: true,
              type: "warning",
              title: t("maximumUploadImages", {
                count: maxUpl,
              }),
              subTitle: t("uploadImagesRemaining", {
                uploaded: imgsSrc.length,
                remaining: maxUpl - imgsSrc.length,
              }),
            })
        : setAlert({
            isOpen: true,
            type: "warning",
            title: t("maximumAllowedSize", {
              size: maxSize,
            }),
            subTitle: t("imageTooLarge", {
              filename: file.name,
              fileSize: (file.size / 1048576).toFixed(2),
              maxSize: maxSize,
            }),
          })
    );

    onChange && onChange({
      name,
      value: values.concat(imgsArray),
    });

    e.target.value = "";
  };

  const rmvImg = (img, index) => {
    setImgsSrc(imgsSrc.filter((e) => e !== img));
    URL.revokeObjectURL(img);
    rmv && rmv(index);
  };

  useEffect(() => {
    src && setImgsSrc(src);
    return () => {
      setImgsSrc(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  return (
    <>
      <Box {...other}>
        <Grid container direction="row" spacing={2}>
          {imgsSrc.map((img, i) => (
            <Grid item xs={12} md={3} xl={2} key={i}>
              <Grow in timeout={1000}>
                <div className="pos-relative">
                  <img
                    className="w-100pr obj-cover c-pointer br-8"
                    src={img}
                    alt={img}
                  />
                  <IconButton
                    color="error"
                    size="small"
                    className="btn-error"
                    onClick={() => rmvImg(img, i)}
                    sx={{ margin: "10px", right: "0", position: "absolute" }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </Grow>
            </Grid>
          ))}
          {/* Upload Image */}
          {imgsSrc.length < maxUpl && (
            <Grid item xs={12} md={3} xl={2} className="pos-relative">
              <label
                htmlFor={name}
                className="w-100pr d-flex j-center bg-whitexs"
                style={{
                  borderTopLeftRadius: "10px",
                  borderTopRightRadius: "10px",
                }}
              >
                <FileUploadRoundedIcon
                  className="obj-cover c-pointer"
                  color="whitemd"
                  sx={{
                    height: "100%",
                    width: "100%",
                    borderBottom: "1px solid",
                  }}
                  src={defImg}
                  alt="Attach a PP Pic"
                />
                <Input
                  accept="image/png, image/gif, image/jpeg, image/jpg"
                  className="d-none"
                  name={name}
                  id={name}
                  onChange={showPreview}
                  type="file"
                  inputProps={{ multiple: false }}
                />
                <Typography
                  variant="span"
                  className="pos-absolute bottom-0 p-10 tx-upp gray-color c-pointer"
                >
                  {label === "Upload Images" ? t("uploadImages") : label}
                </Typography>
              </label>
            </Grid>
          )}
        </Grid>
      </Box>
      <Typography color="error" className="mt-10 font-4">
        {error}
      </Typography>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
}
